// This is the middleware type between SMME and SF
export type DeliveryAPI = {
  address: {
    addressType?: AddressTypeAPI;
    street?: string;
    complexName?: string;
    suburb?: string;
    city?: string;
    province?: string;
    country?: string;
    postalCode?: string;
  };
  /*  price in rands */
  price?: number;
  delivery_option?: string;
  paymentMethodCode?: PaymentMethodCode;
  recipient: {
    name?: string;
    tradingAs?: string;
    idNumber?: string;
    phoneNumberWork?: string;
    phoneNumberCell?: string;
    phoneNumber?: string;
  };
  order: {
    quantity?: number;
    deviceName?: string;
    deviceId?: string;
    acquiringChannel?: string;
    secondaryAcquiringChannel?: string;
    isProductCategory?: boolean;
    serialNumbers?: string[];
    friendlyTerminalName?: string[];
  };
};

export enum AddressTypeAPI {
  BUSINESS = 'BUSINESS',
  OPERATIONAL = 'OPERATIONAL',
}

export enum PaymentMethodCode {
  CASH = 'Cash',
  ONLINE_PAYMENT = 'Online Payment',
  PAYMENT_LINK = 'Payment Link',
  PAYFLEX = 'Payflex',
  PAYFLEX_LINK = 'Payflex Link',
  RENTAL = 'Rental',
  ZERO = 'Zero',
}
